function ParamsError(): JSX.Element {
  return <p>Validation failed due to missing data</p>;
}

export default ParamsError;
